import React from 'react'
import {DataTable, DataTableFilterMeta} from 'primereact/datatable'
import {Column, ColumnFilterElementTemplateOptions} from 'primereact/column'
import {Tag} from 'primereact/tag'
import {Button} from 'primereact/button'
import {ConfirmDialog, confirmDialog} from 'primereact/confirmdialog'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import data from '../dummyData.json'

const titleBodyTemplate = (value) => {
  const trimmedData = {name: value.inquiryName}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      {/* <img alt={trimmedData.name} src={trimmedData.image} width='32' /> */}
      <span className='col'>{trimmedData.name}</span>
    </div>
  )
}

const applicationFormStatusBodyTemplate = (value) => {
  const trimmedData = {name: value.applicationFormStatus}
  return (
    <div className='d-flex align-items-center justify-content-center'>
      <Tag
        className='col-6'
        value={trimmedData.name}
        severity={
          trimmedData.name === 'pending'
            ? 'warning'
            : trimmedData.name === 'rejected'
            ? 'danger'
            : 'success'
        }
      />
    </div>
  )
}
const documentUploadStatusBodyTemplate = (value) => {
  const trimmedData = {name: value.documentUploadStatus}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      <Tag
        className='col-6'
        value={trimmedData.name}
        severity={
          trimmedData.name === 'pending'
            ? 'warning'
            : trimmedData.name === 'rejected'
            ? 'danger'
            : 'success'
        }
      />
    </div>
  )
}
const applicationReviewStatusBodyTemplate = (value) => {
  const trimmedData = {name: value.applicationReviewStatus}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      <Tag
        className='col-6'
        value={trimmedData.name}
        severity={
          trimmedData.name === 'pending'
            ? 'warning'
            : trimmedData.name === 'rejected'
            ? 'danger'
            : 'success'
        }
      />
    </div>
  )
}
const interviewStatusBodyTemplate = (value) => {
  const trimmedData = {name: value.interviewStatus}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      <Tag
        className='col-6'
        value={trimmedData.name}
        severity={
          trimmedData.name === 'pending'
            ? 'warning'
            : trimmedData.name === 'rejected'
            ? 'danger'
            : 'success'
        }
      />
    </div>
  )
}

export default function InquiryDataTableAndActions() {
  const accept = () => {
    console.log('accept')
  }
  const reject = () => {
    console.log('reject')
  }
  const confirm = (header, message) => {
    confirmDialog({
      message,
      header,
      position: 'top',
      acceptLabel: 'Accept',
      rejectLabel: 'Reject',
      acceptClassName: `${
        header === 'Reject Application' ? 'd-none' : ''
      } p-button-info rounded-pill px-8`,
      rejectClassName: `${
        header === 'Accept Application' ? 'd-none' : ''
      } rounded-pill px-8 p-button-danger`,
      accept,
      reject,
    })
  }
  const inquiryActionBodyTemplate = () => {
    return (
      <div className='d-flex justify-content-center align-items-center gap-2'>
        <Button
          label='review'
          rounded
          outlined
          severity='success'
          className='px-8'
          style={{
            borderRadius: '2rem',
          }}
        />
        <Button
          label='accept'
          rounded
          severity='success'
          className='px-8'
          style={{
            borderRadius: '2rem',
          }}
          onClick={() =>
            confirm(
              'Accept Application',
              'Are you sure you want to approve the application and confirm that the applicant has completed all required processes?'
            )
          }
        />
        <Button
          label='reject'
          rounded
          severity='danger'
          className='px-8'
          style={{
            borderRadius: '2rem',
          }}
          onClick={() =>
            confirm(
              'Reject Application',
              'Are you sure you want to reject this application? Once rejected, the decision cannot be undone, and a new application will need to be initiated.'
            )
          }
        />
      </div>
    )
  }
  const inquiryColumns = [
    <Column
      field='inquiryName'
      body={titleBodyTemplate}
      // filterPlaceholder='Search by title'
      showFilterMenu={false}
      alignHeader='center'
      // filter
      sortable
      sortField='inquiryName'
      frozen
      header='Name'
      key='inquiryName'
    />,

    <Column
      field='inquiryDate'
      align='center'
      alignHeader='center'
      sortable
      className='col-2'
      header='Inquiry Date'
      key='date'
    />,

    <Column
      field='applicationFormStatus'
      // filterField='author'
      sortField='applicationFormStatus'
      alignHeader='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Application Form'
      body={applicationFormStatusBodyTemplate}
      key='applicationFormStatus'
    />,
    <Column
      field='documentUploadStatus'
      // filterField='author'
      sortField='documentUploadStatus'
      alignHeader='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Document Upload'
      body={documentUploadStatusBodyTemplate}
      key='documentUploadStatus'
    />,
    <Column
      field='applicationReviewStatus'
      // filterField='author'
      sortField='applicationReviewStatus'
      alignHeader='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Application Review'
      body={applicationReviewStatusBodyTemplate}
      key='applicationReviewStatus'
    />,
    <Column
      field='interviewStatus'
      // filterField='author'
      sortField='interviewStatus'
      alignHeader='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Interview/Test'
      body={interviewStatusBodyTemplate}
      key='interviewStatus'
    />,

    <Column
      header='Actions/Status'
      alignHeader='center'
      // headerClassName=''
      body={inquiryActionBodyTemplate}
      exportable={false}
      // style={{minWidth: '10rem'}}
      key='actions'
    />,
  ]
  return (
    <>
      <ConfirmDialog draggable={false} style={{maxWidth: '36vw'}} />
      <div className='row'>
        <DataTable
          value={data.inquiryTableValues}
          showGridlines
          paginator
          rows={20}
          rowsPerPageOptions={[1, 2, 5, 10, 20, 25, 50, 100]}
          size='normal'
          tableStyle={{minWidth: '50rem'}}
          // filters={tableFilters}
          removableSort
          emptyMessage='No Inquiries have been added for the selected filters.'
          paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
          currentPageReportTemplate='Showing {first} to {last} of {totalRecords} Inquiries'
          scrollable
          // filterDisplay='row'
        >
          {inquiryColumns}
        </DataTable>
      </div>
    </>
  )
}
